import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ActionsSubject, Store } from '@ngrx/store';

import { SharedModule } from '@modules/shared/shared.module';
import { NgZorroAntdModule } from '@public-page/ng-zorro-antd/ng-zorro-antd.module';

import { FormService } from '@modules/core/services';
import { AuthorizationActions, AuthorizationApiActions } from '@modules/authorization/store/auth';
import { ofType } from '@ngrx/effects';
import { Subject, takeUntil } from 'rxjs';
import { BaseForm } from '@modules/core/abstract-classes';
import { ModelFormGroup } from '@modules/core/types';
import { ForgotPasswordForm, ResetPasswordPayload } from '@modules/core/interfaces';

@Component({
  selector: 'pub-forgot-password-page',
  standalone: true,
  imports: [CommonModule, NgZorroAntdModule, SharedModule, ReactiveFormsModule],
  providers: [FormService],
  templateUrl: './forgot-password-page.component.html',
  styleUrls: ['./forgot-password-page.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForgotPasswordPageComponent extends BaseForm implements OnInit, OnDestroy {
  form!: FormGroup<ModelFormGroup<ForgotPasswordForm>>;
  showSucceessInfo = false;
  destroy$ = new Subject();

  constructor(
    private store: Store,
    private actionsListener$: ActionsSubject,
    private location: Location,
    private cdRef: ChangeDetectorRef
  ) {
    super('initForgotPasswordForm');
  }

  get email() {
    return this.form.controls['email'].value;
  }

  ngOnInit(): void {
    this.actionsListener$
      .pipe(ofType(AuthorizationApiActions.resetPasswordSuccess))
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.showSucceessInfo = true;
        this.cdRef.detectChanges();
      });
  }

  resetPassword(): void {
    if (this.form.valid) {
      this.store.dispatch(AuthorizationActions.resetPassword({ payload: this.form.value as ResetPasswordPayload }));
    } else {
      this.checkValidation();
    }
  }

  back(): void {
    this.location.back();
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
